import axios from 'axios';

// Sito ecommerce → Redirect: URL del sito pubblico non trovati e redirect attivi
const state = {
	items: [],
};

const getters = {
	getItems: state => state.items,
};

const auth = context => ({ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });
const url = (context, path) => `${context.rootGetters['settings/getUrl']}${path}`;

const actions = {
	// le due schede della lista leggono da due endpoint diversi con gli stessi parametri
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		const filters = settings.filters || {};
		const notFound = filters.tab !== 'redirects';
		const res = await axios.post(
			url(context, notFound ? 'notfound' : 'redirects'),
			{
				data: {
					sortBy: sortBy[0],
					sortDesc: sortDesc[0] ? 1 : 0,
					page,
					itemsPerPage,
					search: settings.search,
					type: filters.type || '',
					...(notFound ? { status: filters.status || '' } : {}),
				},
			},
			auth(context),
		);
		context.commit('setItems', res.data.data);
		return res.data.pagination;
	},
	setNotFoundStatus: async (context, { id, status }) => (await axios.put(url(context, `notfound/${id}/status`), { status }, auth(context))).data.data,
	fetchNotFound: async (context, id) => (await axios.get(url(context, `notfound/${id}`), auth(context))).data.data,
	fetchSuggestions: async (context, { id, lang }) => (await axios.get(url(context, `notfound/${id}/suggest`), { ...auth(context), params: { lang: lang || undefined } })).data.data,
	fetchRedirect: async (context, id) => (await axios.get(url(context, `redirects/${id}`), auth(context))).data.data,
	saveRedirect: async (context, { id, form }) =>
		id ? (await axios.put(url(context, `redirects/${id}`), form, auth(context))).data.data : (await axios.post(url(context, 'redirects/create'), form, auth(context))).data.data,
	removeRedirect: async (context, id) => (await axios.delete(url(context, `redirects/${id}`), auth(context))).data.data,
	destroyData: context => {
		context.commit('setItems', []);
	},
};

const mutations = {
	setItems: (state, value) => {
		state.items = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
